// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { KindKeyQuality } from "../schema";

export function serialize_KindKeyQuality_internal(value: KindKeyQuality): unknown {
  return ((value: "key-quality"): unknown => {
    return value;
  })(value);
}
export function serialize_KindKeyQuality(obj: KindKeyQuality): string {
  return renderJsonWithNumbersAsBigint(serialize_KindKeyQuality_internal(obj));
}
export function deserialize_KindKeyQuality_internal(value: unknown): ParserResult<KindKeyQuality> {
  return ((value: unknown): ParserResult<"key-quality"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "key-quality":
        return { success: true, value: "key-quality" };
      default:
        return { success: false, reason: `[#/components/schemas/KindKeyQuality]: '${value}' expected to be enum, one of 'key-quality'.` };
    }
  })(value);
}
export function deserialize_KindKeyQuality(str: string): ParserResult<KindKeyQuality> {
  return deserialize_KindKeyQuality_internal(parseJsonWithNumbersAsBigint(str));
}
